import { Box, BoxProps, Heading, Text } from '@wix/design-system';
import { Check } from '@wix/wix-ui-icons-common/lazy';
import React from 'react';

interface BannerLayoutProps extends BoxProps {
  title: string;
  items: (string | React.ReactNode)[];
  backgroundColor?: string;
}

export const BannerLayout = ({
  title,
  items,
  backgroundColor = '#06063a',
}: BannerLayoutProps) => {
  return (
    <Box
      direction="horizontal"
      width="100%"
      padding="126px 48px 96px"
      boxSizing="border-box"
      gap="100px"
      backgroundColor={backgroundColor}
    >
      <Box maxWidth="254px" minWidth="236px">
        <Heading light size="extraLarge">
          {title}
        </Heading>
      </Box>
      <Box gap="24px">
        <Box display="block" minWidth="648px" maxWidth="760px" columnCount={2}>
          {items.map((item, idx) => (
            <Box
              marginBottom="30px"
              verticalAlign="middle"
              maxWidth="max-content"
              gap="SP1"
              key={idx}
            >
              <Check color="white" />
              <Text light weight="bold">
                {item}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
